import { createI18n } from 'vue-i18n'
import ru from '@/locales/ru.json'

type MessageSchema = typeof ru

const i18n = createI18n<[MessageSchema], 'ru'>({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru,
  },
})

export default i18n
